import React, { useState, useCallback } from 'react';
import { Close as CloseIcon, Search as SearchIcon } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, MenuItem, Select, TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { dspAtom, dspDrivers } from '../../reducers/DspReducer';

const useStyles = makeStyles()((theme) => ({
  searchForm: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
  },
  searchInput: {
    flexGrow: 2,
    marginLeft: 15,
    backgroundColor: '#fff',
    '&>.MuiInputBase-root': {
      fontSize: 14,
      '&>.MuiOutlinedInput-input': {
        paddingTop: '12px',
        paddingBottom: '12px',
      },
    },
  },
  searchIcon: {
    color: '#bebfc0',
  },
  closeBtn: {
    padding: '8px',
  },
  searchLabel: {
    lineHeight: '40px',
    width: 'auto',
    minWidth: 'auto !important',
    padding: '0px 10px',
  },
  fitler: {
    backgroundColor: '#fff',
    display: 'flex',
    color: '#aeaeae',
    '& .MuiSelect-select:focus': {
      backgroundColor: '#fff',
    },
    alignItems: 'center',
  },
  selectColor: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    // maxHeight: "44px"
  },
}));

const searchFields = [
  { value: 'id', label: 'DSP COURIERS' },
  { value: 'company', label: 'DSP DRIVERS' },
];

const SearchForm = ({ getList, initValue, placeholder }) => {
  const [searchValue, setSearchValue] = useState(initValue); // useRecoilValue():
  const [dpsFilter, updateDspFilter] = useRecoilState(dspAtom);
  const [dspDriverFilter, updateDspDriverFilter] = useRecoilState(dspDrivers);
  const resetDspState = useResetRecoilState(dspAtom);
  const resetDspDriverState = useResetRecoilState(dspDrivers);
  const navigate = useNavigate();
  const isDspScreen = window.location.href.includes('drivers') ? false : true;

  const searchAction = useCallback(
    (e) => {
      e.preventDefault();
      getList({ q: searchValue });
    },
    [searchValue],
  );
  const removeSearchAction = () => {
    setSearchValue('');
    updateDspFilter({ ...dpsFilter, q: '' });
    updateDspDriverFilter({ ...dspDriverFilter, q: '' });
  };
  const handleChangeSelect = (e) => {
    resetDspState();
    resetDspDriverState();
    const val = e.target.value;
    setSearchValue('');
    window.setTimeout(() => {
      if (val === 'company') {
        navigate('/dsp/drivers');
      } else {
        navigate('/dsp');
      }
    }, 10);
  };
  const handleChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };
  function handleKeyDown(e) {
    if (e.key === 'Enter' || e.target.value === null) {
      if (isDspScreen === true) {
        updateDspFilter({ ...dpsFilter, page: 0, q: e.target.value });
      } else {
        updateDspDriverFilter({
          ...dspDriverFilter,
          page: 0,
          q: e.target.value,
        });
      }
    }
  }
  const { classes } = useStyles();

  return (
    <form className={classes.searchForm} onSubmit={searchAction} noValidate autoComplete="off">
      <Box className={classes.fitler}>
        <Box className={classes.searchLabel}>Search By</Box>
        <Select
          // id="standard-select-searchfield"
          value={window.location.pathname === '/dsp/drivers' ? 'company' : 'id'}
          sx={{
            boxShadow: 'none',
            '.MuiOutlinedInput-notchedOutline': { border: 0 },
          }}
          classes={{
            root: classes.selectColor,
          }}
          size="small"
          onChange={handleChangeSelect}
        >
          {searchFields.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <TextField
        onChange={handleChangeSearch}
        variant="outlined"
        id="standard-start-adornment"
        value={searchValue}
        className={classes.searchInput}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment className={classes.searchIcon} position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchValue && (
              <IconButton className={classes.closeBtn} onClick={() => removeSearchAction()} size="large">
                <CloseIcon />
              </IconButton>
            ),
          },
        }}
      />
    </form>
  );
};
export default React.memo(SearchForm);
